import type {Theme} from './Theme';

// Follow format <propertyName>:<property-value> /* <Figma variable name */
export const themeV1: Theme = {
  // Theme colors
  surface:
    'linear-gradient(0deg, rgb(56 106 32 / 5%), rgb(56 106 32 / 5%)), linear-gradient(0deg, rgb(118 119 114 / 2%), rgb(118 119 114 / 2%)), linear-gradient(0deg, #fdfdf6, #fdfdf6)' /* GFiber-GM3/read-only/light/surface4 */,
  surfaceVariant: '#FDFDF6' /* material-theme/sys/light/surface */,
  onSurface: '#1A1C18',
  onSurfaceVariant: '#43493E',
  onSurfaceVariantSecondary: '#444746',
  background: '#FDFDF6' /* material-theme/sys/light/surface */,
  primary: '#386A20' /* GFiber-GM3/sys/light/primary */,
  onPrimary: '#FFFFFF',
  secondary: '#137333' /* Baseline colors/Green/800 */,
  transparent: 'transparent',
  onTransparent: '#386A20',
  backgroundBrand: '#D9E7CB' /* GFiber-GM3/sys/light/secondary-container */,
  onBackgroundBrand: '#042100' /* GFiber-GM3/sys/light/on-primary-container */,
  textSecondary: '#55624c' /* GFiber-GM3/sys/light/secondary-container dark */,
  surfacePrimaryGradient:
    'linear-gradient(0deg, rgb(56 106 32 / 5%), rgb(56 106 32 / 5%)), linear-gradient(0deg, rgb(118 119 114 / 2%), rgb(118 119 114 / 2%)), linear-gradient(0deg, #fdfdf6, #fdfdf6)' /* GFiber-GM3/read-only/light/surface4 */,
  surfaceSecondaryGradient:
    'linear-gradient(0deg, rgb(56 106 32 / 12%), rgb(56 106 32 / 12%)), linear-gradient(0deg, rgb(118 119 114 / 2%), rgb(118 119 114 / 2%)), #fdfdf6' /* GFiber-GM3/read-only/light/surface */,
  headerBg: '#FDFDF6',
  footerBg: '#FDFDF6',

  // Brand colors
  blueCore: '#4285F4' /* Figma: Brand colors/Google Blue 500 */,
  greenCore: '#34A853' /* Figma: Brand colors/Google Green 500 */,
  redCore: '#EA4335' /* Figma: Brand colors/Google Red 500 */,
  yellowCore: '#FBBC04' /* Figma: Brand colors/Google Yellow 500 */,

  // Utilitary colors
  white: '#FFFFFF',
  black: '#000000',
  grey100: '#F1F3F4' /*Baseline colors/Grey/100 */,
  grey200: '#f0f3e8' /* Baseline colors/Grey/200 */,
  grey300: '#DADCE0' /* Baseline colors/Grey/300 */,
  grey400: '#bdc1c6' /* Baseline colors/Grey/400 */,
  grey700: '#5F6368' /* Baseline colors/Grey/700 */,
  grey800: '#3c4043' /* Baseline colors/Grey/800 */,
  green600: '#1E8E3E',
  neutral50: '#767772' /* GFiber-GM3/ref/neutral/neutral50 */,
  accountMenuBtnText: '#3c4043',
  warning: '#e37400',
  warningContainer: '#feefc3',
  networkItemOk: '#d9e7cb' /* GFiber-GM3/sys/light/secondary-container */,

  // Alerts
  globalAlertInfo: '#F1F1EA' /* GFiber-GM3/re/neutral/neutral95 */,
  onGlobalAlertInfo: '#74796E' /* GFiber-GM3/android/light/textColorTertiary */,
  globalAlertError: '#F9E5E5' /* GFiber-GM3/sys/light/error-container */,
  onGlobalAlertError: '#BA1B1B' /* GFiber-GM3/sys/light/error */,
  globalAlertWarning: '#FFF2B4',
  onGlobalAlertWarning: '#1A1C18' /* Figma: GFiber-GM3/sys/light/on-surface */,

  // Error related colors
  formError: '#B00020' /* Base set (Default)/error */,
  errorRed: '#c00',
  errorIconRed: '#d32f2f',
  errorDialogBg: '#f2b8b5' /* GFiber-GM3/sys/light/error */,
  errorDialogIcon: '#b3261e' /* GM3/sys/light/error */,
  red600: '#d93025' /* Baseline colors/Red/600 */,

  // Buttons
  btnPrimaryBg: '#386A20',
  btnPrimaryText: '#FFFFFF',
  btnPrimaryHoverBg: '#386A20',
  btnPrimaryHoverShadow:
    '0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12)',
  btnPrimaryFocusActiveBg: '#386A20',
  btnPrimaryDisabledBg: 'rgb(0 0 0 / 12%)',
  btnPrimaryDisabledText: 'rgb(0 0 0 / 26%)',
  btnSecondaryBg: 'transparent',
  btnSecondaryText: '#386A20',

  btnSecondaryHoverBg: 'transparent',
  btnSecondaryFocusActiveBg: 'rgb(0 0 0 / 8%)',

  btnTertiaryBg: '#FDFDF6',
  btnTertiaryText: '#000000',
  btnTertiaryHoverBg: '#eeeff1',
  btnTertiaryFocusActiveBg: '#e3e4e6',
  btnCompactBg: 'transparent',
  btnCompactText: '#386A20',
  btnCompactHoverText: '#386A20',
  btnCompactFocusActiveText: '#386A20',
  focusOutline: '#386A20',
  outline: '#74796E' /* material-theme/sys/light/outline */,
  linkText: '#386A20',
  linkHoverText: '#386A20',

  //Form field colors
  formFieldBg:
    'linear-gradient(0deg, rgb(56 106 32 / 5%), rgb(56 106 32 / 5%)), linear-gradient(0deg, rgb(118 119 114 / 2%), rgb(118 119 114 / 2%)), linear-gradient(0deg, #fdfdf6, #fdfdf6)',
  formFieldBorder: '#80868b',
  formFieldOutlineFocus: '#386a20',
  formFieldOutlineError: '#ea4335',
  formFieldLabel: '#63645e',
  formFieldLabelFocus: '#386a20',
  formFieldLabelError: '#ea4335',
  formFieldValue: '#23241d',

  //Switch
  switchCheckedBg: '#82BA65',

  // Navigation
  navText: '#5f6368',
  navTextSecondary: '#62666b',
  navHoverBg: '#f8f9fa',

  // Fonts
  fontPrimary: "'Google Sans', 'Helvetica Neue', sans-serif",
};
